// extracted by mini-css-extract-plugin
export default {"main":"StaffOverview_main__32Mj9","button":"StaffOverview_button__W0UDo"};